module.exports = "/packs/ribbon-52d0659797fc1ede783adbd82dae79b4.svg";